// extracted by mini-css-extract-plugin
export default {"amountList":"select-amount_amountList__dQ83y"};